var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGauge1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 138,
    viewBox: "0 0 222 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_106935)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 138,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 138,
    transform: "translate(1.55078)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.193 68.4345C201.555 67.7964 203.176 68.3833 203.814 69.7454C213.298 89.9894 216.089 112.727 211.782 134.664C211.492 136.14 210.06 137.101 208.584 136.812C207.108 136.522 206.147 135.09 206.437 133.614C210.521 112.813 207.874 91.2523 198.882 72.0562C198.244 70.6941 198.83 69.0726 200.193 68.4345Z",
    fill: "#C7291B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.555 20.1573C148.161 18.7804 149.768 18.1551 151.145 18.7606C171.609 27.7602 188.675 43.0426 199.87 62.3927C200.623 63.6947 200.178 65.3608 198.876 66.114C197.574 66.8673 195.908 66.4225 195.155 65.1205C184.539 46.7719 168.357 32.2805 148.952 23.7468C147.575 23.1413 146.95 21.5342 147.555 20.1573Z",
    fill: "#D8863D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8313 19.0468C75.3682 17.6157 76.1529 16.0802 77.584 15.6171C98.8533 8.7343 121.762 8.80353 142.989 15.8147C144.417 16.2864 145.193 17.8267 144.721 19.255C144.249 20.6833 142.709 21.4587 141.281 20.9869C121.152 14.3387 99.4295 14.273 79.261 20.7995C77.8299 21.2626 76.2944 20.4779 75.8313 19.0468Z",
    fill: "#EAAD07"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3436 65.5445C20.0503 64.7765 19.6245 63.1054 20.3926 61.8121C31.8074 42.5908 49.0467 27.504 69.6117 18.7382C70.9954 18.1484 72.5952 18.792 73.185 20.1757C73.7748 21.5594 73.1312 23.1593 71.7475 23.7491C52.247 32.0611 35.9 46.3671 25.076 64.5935C24.308 65.8868 22.6369 66.3126 21.3436 65.5445Z",
    fill: "#BBDBFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4622 136.654C12.9987 137.002 11.5305 136.098 11.1828 134.634C6.01538 112.884 7.90835 90.0541 16.5874 69.4524C17.1713 68.0662 18.7685 67.4159 20.1546 67.9998C21.5408 68.5838 22.1911 70.1809 21.6072 71.5671C13.3774 91.1025 11.5824 112.751 16.4824 133.375C16.8301 134.839 15.9256 136.307 14.4622 136.654Z",
    fill: "#BBDBFE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_371_106935)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.2374,
    cy: 102.237,
    r: 8.20104,
    transform: "rotate(0.25 11.2374 102.237)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.2374,
    cy: 102.237,
    r: 8.20104,
    transform: "rotate(0.25 11.2374 102.237)",
    stroke: "#BBDBFE",
    strokeWidth: 5.44706
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_371_106935",
    x: -16.773,
    y: 84.478,
    width: 56.0206,
    height: 56.0201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.4171
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4171
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_371_106935"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.2513
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54275
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_371_106935",
    result: "effect2_dropShadow_371_106935"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_371_106935",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_106935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 138,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge1);
export default __webpack_public_path__ + "assets/media/gauge-1.bab51e9e.svg";
export { ForwardRef as ReactComponent };